import { render } from "./InviteUserToConversation.vue?vue&type=template&id=6c3cd84e&scoped=true"
import script from "./InviteUserToConversation.vue?vue&type=script&lang=js"
export * from "./InviteUserToConversation.vue?vue&type=script&lang=js"

import "./InviteUserToConversation.vue?vue&type=style&index=0&id=6c3cd84e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3cd84e"]])

export default __exports__